import { html, ref } from '@microsoft/fast-element';
import { positionIcon } from '../../../../../styles';
import type { DrilldownNodalLmeGraph } from './drilldown-nodal-lme-graph';

export const DrilldownNodalLmeGraphTemplate = html<DrilldownNodalLmeGraph>`
    <div class="graph-div""> 
        <div class="title-menu">
            <div class="graph-title">Nodal LME - Historical</div>
        </div>
        <div ${ref('nodalLmeHistoricalChart')}></div>
    </div>
`;
